import type { RouteResource } from 'react-resource-router';

import type { ResponderItemResponse } from '@atlassian/eoc-responder-names';

import type { UserAccessRights } from '../../common/mocks/user-access-rights/types';
import { configuredSyncsResource } from '../configured-syncs/resources';
import type { ConfiguredSyncsResource } from '../configured-syncs/resources/types';
import { isCurrentSiteSyncEnabledResource } from '../is-current-site-sync-enabled-resource';
import { getTeamResource } from '../team-resource';
import { userAccessRightsResource } from '../user-access-rights/resources';

export const resources: {
	configuredSyncsResource: RouteResource<ConfiguredSyncsResource>;
	getTeamResource: RouteResource<ResponderItemResponse | null>;
	isCurrentSiteSyncEnabledResource: RouteResource<boolean | null>;
	userAccessRightsResource: RouteResource<UserAccessRights>;
} = {
	configuredSyncsResource,
	userAccessRightsResource,
	getTeamResource,
	isCurrentSiteSyncEnabledResource,
};
